import { type IconConfig, type Project } from '@littlebird/sdk';

export interface ProjectMenuOption {
  id: string;
  name: string;
  icon: IconConfig | null;
  isSelected: boolean;
}

export function toProjectMenuOption(
  project: Project,
  isSelected: boolean
): ProjectMenuOption {
  return {
    id: project.id,
    name: project.name,
    icon: project.icon,
    isSelected,
  };
}
